define('type/article/Serum.CommentThread',['common/js/lib/Serum.Pubsub'], function(Pubsub){
  'use strict';

  //See https://confluence.nrk.no/pages/viewpage.action?pageId=24611222
  var COMMENTS_LOAD_REGEXP = /^#(comment-\d+|disqus_thread)$/;
  var COMMENTS_LOAD_BUTTON = '.article-comments-load';

  function setupForum(config){
    if(config.loadButton){
      config.loadButton.outerHTML = '';  //Remove load-button
    }

    require(['https://' + config.forum + '.disqus.com/embed.js'], function(){
      window.DISQUS.reset({
        reload: true,
        config: function() {
          this.page.identifier = config.identifier;
          this.page.url = location.href.split(/[?#]/)[0]; //URL without hash or query
          this.callbacks.onNewComment = [trackComment];
        }
      });
    });
  }

  function setupButton(config){
    var countScript = document.createElement('script');
    countScript.src = 'https://' + config.forum + '.disqus.com/count.js';
    countScript.id = 'dsq-count-scr';
    countScript.async = true;
    document.body.appendChild(countScript);

    config.loadButton.addEventListener('click', function(){
      setupForum(config);
      trackLoadClick();
    });
  }

  function trackLoadClick(){
    Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
      category : 'Comments',
      action : 'Click'
    });
  }

  function trackComment(comment) {
    Pubsub.publish(Pubsub.topics.TRACK_EVENT, {
      category : 'Comments',
      action : 'Comment',
      label : comment.id
    });
  }

  return {
    initialize: function(element){
      var config = {
        forum: element.getAttribute('data-comments-forum'),
        identifier: element.getAttribute('data-comments-identifier'),
        loadButton: element.querySelector(COMMENTS_LOAD_BUTTON),
        shouldLoad: location.hash.match(COMMENTS_LOAD_REGEXP)
      };

      if(!config.loadButton || config.shouldLoad){
        setupForum(config);
      }else{
        setupButton(config);
      }
    }
  };
});

